import * as ContextEvents from "./context";
import * as ProjectEvents from "./project";
import * as DragDropEvents from "./dragDrop";
import * as UploadEvents from "./upload";
import * as DownloadEvents from "./download";
import * as TabelRowEvents from "./tableRowCommited";
import * as TableResizeEvents from "./tableResize";

export const EventsRegistry = {
  ...TableResizeEvents,
  ...ContextEvents,
  ...ProjectEvents,
  ...DragDropEvents,
  ...UploadEvents,
  ...DownloadEvents,
  ...TabelRowEvents,
};
